import React from 'react';

//
// Slow reassurance ticker — pure CSS, paused on hover, respects
// prefers-reduced-motion (in which case it renders as a static row).
//
// Usage:
//   <Marquee items={['Item A', 'Item B', ...]} />
//
// Implementation: render the items twice in a row that scrolls -50% across
// a 30-second loop, so the duplicated content joins seamlessly.
//
export default function Marquee({
  items = [],
  speedSec,                // mobile speed (also fallback for desktop if unset)
  desktopSpeedSec,         // separate speed at sm breakpoint and up
  className = '',
  bg = 'bg-canvas',
  text = 'text-ink-700',
  divider = '•',
}) {
  if (!items.length) return null;

  const mobile = speedSec != null ? speedSec : 5;
  const desktop = desktopSpeedSec != null ? desktopSpeedSec : 9;

  return (
    <div className={`relative overflow-hidden border-y border-ink-200 ${bg} ${className}`}>
      {/* Edge fades — keeps the loop seam invisible. */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-current to-transparent opacity-0" />
      <div
        className="marquee-track flex gap-12 py-3.5 whitespace-nowrap"
        style={{
          '--marquee-mobile': `${mobile}s`,
          '--marquee-desktop': `${desktop}s`,
        }}
      >
        {[0, 1].map((dup) => (
          <ul
            key={dup}
            aria-hidden={dup === 1 ? 'true' : 'false'}
            className={`flex shrink-0 gap-12 items-center text-sm ${text}`}
          >
            {items.map((item, i) => (
              <li key={`${dup}-${i}`} className="flex items-center gap-3">
                {typeof item === 'string' ? <span>{item}</span> : item}
                <span aria-hidden="true" className="text-ink-300">{divider}</span>
              </li>
            ))}
          </ul>
        ))}
      </div>
    </div>
  );
}
